<template>
  <div name="check-status-button">
    <div @click="countSelect()" :class="[ flgSelectCount == 0 ? 'select-none' : 'select-checked' ]" class="cursor-pointer">
      <i :class="'fa fa-' + [ flgSelectCount == 0 ? 'circle-o-notch' : 'check-circle' ]" class="icon-select"></i>{{selectDesc}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'check-status-button',
  data () {
    return {
      flgSelect: this.value,
      flgSelectCount: 0,
      selectDesc: 'None'
    }
  },
  mounted () {
    this.valueChange(this.value)
  },
  watch: {
    value (newVal) {
      this.valueChange(newVal)
    }
  },
  props: {
    value: {
      type: String
    },
    select: {
      type: String
    },
    selectRowBool: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    countSelect () {
      if (this.selectRowBool) {
        this.$emit('setDefaultSelect')
      }
      this.flgSelectCount++
      if (this.flgSelectCount > 1) {
        this.flgSelectCount = 0
      }
      switch (this.flgSelectCount) {
        case 0:
          this.flgSelect = ''
          this.selectDesc = 'None'
          break
        case 1:
          this.flgSelect = 'Y'
          this.selectDesc = 'Checked'
          break
      }
      this.$emit('input', this.flgSelect)
    },
    valueChange (newVal) {
      this.flgSelect = newVal.trim()
      switch (this.flgSelect) {
        case '':
          this.flgSelectCount = 0
          this.selectDesc = 'None'
          break
        case 'Y':
          this.flgSelectCount = 2
          this.selectDesc = 'Checked'
          break
        default:
          this.flgSelect = ''
          this.flgSelectCount = 0
          this.selectDesc = 'None'
          break
      }
      this.$emit('input', this.flgSelect)
    }
  }
}
</script>

<style>
.icon-select{
  margin:0 5px 0 0;
}
.select-none {
  transition: background 0.3s ease;
  background:#e4e0e0;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 80px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#666;
  font-weight:700;
  font-size:12px;
}
.select-checked {
  transition: background 0.3s ease;
  background:#66BB6A;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 80px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#FFF;
  font-size:12px;
}
</style>


// WEBPACK FOOTER //
// checkStatus.vue?3f6d5be9